export const siteInfo = {
  name: "AUTO BOB Transport vozila - Šlep služba",
  slogan: "Brza Pomoć na Putu - 24/7",
  tagline: "Vaš Pouzdan Partner Kada Ostanete u Nevolji",
  contact: {
    phone: "064 912 55 67",
    phoneDisplay: "064 912 55 67",
    email: "autobob21@gmail.com",
    address: "Jorgovanska 7, Novi Sad",
    mapLink: "https://share.google/6U9PYA3CiTgobU1wW"
  },
  social: {
    instagram: "https://www.instagram.com/auto_bob_ns",
    instagramHandle: "@auto_bob_ns"
  },
  stats: {
    years: "10+",
    vehicles: "5000+",
    satisfaction: "100%"
  }
};

export const navItems = [
  { label: "Početna", href: "#home" },
  { label: "Usluge", href: "#services" },
  { label: "Zona Pokrivenosti", href: "#coverage" },
  { label: "Galerija", href: "#gallery" },
  { label: "Recenzije", href: "#reviews" },
  { label: "Kontakt", href: "#contact" },
];
